import styled from 'styled-components';
import dropdownIcon from '../../../images/dropdown-icon.svg';

export const Container = styled.div`
&.DropdownWrapper{
  position: relative;
  box-sizing: border-box;
}
&.ShownItem{
  border-radius: 5px;
  display: flex;
  justify-content: center;
  border: 1px solid #C4C4C4;
  cursor: pointer;
  width: 120px;
  height: 35px;
  background-color: #fff;
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 5px;
}
&.ShownItem::after{
  content: url(${dropdownIcon});
  position: absolute;
  right: 14px;
  top: 2px;
}
&.DropdownItems{
  position: absolute;
  border: 1px solid #C4C4C4;
  box-sizing: border-box;
  border-radius: 5px;
  width: 120px;
  background-color: #fff;
  z-index: 1;
  flex-direction: column;
}
`;

export const StyledSpan = styled.span`
cursor: pointer;
padding: 5px;
&:hover{
  background: #ccc;
}
`;